import Menu from "@material-symbols/svg-500/rounded/menu.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const MenuIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Menu });
	return <Icon />;
};

export default memo(MenuIcon);
